import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Modal,
  TextField,
  Card,
  CardContent,
  CardActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function ConfirmationModal({ open, data, onConfirm, onClose }) {
  const theme = useTheme();
  const [editedEquipmentName, setEditedEquipmentName] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const hasError = isTouched && !editedEquipmentName.trim();

  useEffect(() => {
    // Garante que o nome do equipamento não exceda 35 caracteres ao carregar
    setEditedEquipmentName((data?.equipmentName ?? '').slice(0, 35));
    setIsTouched(false);
  }, [data]);

  const handleConfirmClick = () => {
    if (!editedEquipmentName.trim()) {
      setIsTouched(true);
      return;
    }
    onConfirm(editedEquipmentName.trim());
  };

  const handleInputChange = (e) => {
    // Limita a entrada do usuário a 35 caracteres
    setEditedEquipmentName(e.target.value.slice(0, 35));
  };

  if (!open) {
    return null;
  }

  return (
    <Modal
      open={open}
      aria-labelledby="modal-title"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Card
        sx={{
          minWidth: 400,
          maxWidth: '90vw',
          borderRadius: 2,
          boxShadow: 12,
          borderTop: `4px solid ${theme.palette.primary.main}`,
          p: 1,
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <CheckCircleOutlineIcon
              color="primary"
              sx={{ mr: 1.5, fontSize: '2rem' }}
            />
            <Typography id="modal-title" variant="h5" component="h2">
              Finalizar Atendimento
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Para registrar o histórico, confirme o equipamento atendido para o
            cliente:
          </Typography>
          <Box
            sx={{
              backgroundColor: 'action.hover',
              p: 1.5,
              borderRadius: 1,
              textAlign: 'center',
              mb: 2,
            }}
          >
            <Typography variant="subtitle1" component="strong">
              {data?.clientName}
            </Typography>
          </Box>
          <TextField
            fullWidth
            label="Equipamento Atendido"
            variant="outlined"
            value={editedEquipmentName}
            onChange={handleInputChange} // Atualizado para usar a função com limite
            onFocus={() => setIsTouched(true)}
            onBlur={() => setIsTouched(true)}
            error={hasError}
            helperText={
              hasError
                ? 'É necessário informar o equipamento do cliente.'
                : `${editedEquipmentName.length}/35 caracteres` // Contador de caracteres atualizado
            }
            InputLabelProps={{ shrink: true }}
          />
          <Typography
            variant="caption"
            display="block"
            sx={{ mt: 1, color: 'text.secondary' }}
          >
            Este dado será usado para métricas no dashboard. Confirme se o nome está
            correto ou insira o equipamento certo.
          </Typography>
        </CardContent>
        <CardActions sx={{ p: '0 24px 24px', justifyContent: 'flex-end' }}>
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            onClick={handleConfirmClick}
            disabled={!editedEquipmentName.trim()}
          >
            Confirmar e Finalizar Atendimento
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

export default ConfirmationModal;
